shadow$provide[379] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `void setFragmentColor(vec4 color) {
  if (color.a >= 1.0) discard;
  gl_FragColor = color;
}`;

};